import React, { useState } from 'react'
import { Routes, Route } from 'react-router-dom'
import PremiumLandingScreen from './PremiumLandingScreen'
import EnterPhoneNumberScreen from './EnterPhoneNumberScreen'
import EnterVerificationCodeScreen from './EnterVerificationCodeScreen'
import BuyPremiumScreen from './BuyPremiumScreen'
import PremiumSuccessScreen from './PremiumSuccessScreen'
import PremiumCancelScreen from './PremiumCancelScreen'

const PremiumRoute = () => {
  // In development, append ?preview to the URL to skip auth and go straight to BuyPremiumScreen
  const isPreview =
    process.env.NODE_ENV === 'development' &&
    new URLSearchParams(window.location.search).has('preview')

  const [step, setStep] = useState(isPreview ? 'buy' : 'landing') // 'landing' | 'enterPhone' | 'enterCode' | 'buy'
  const [phoneData, setPhoneData] = useState(null) // { mobileNumber, countryCode, requestId }
  const [uid, setUid] = useState(isPreview ? 'preview-uid' : null)
  const [userEmail, setUserEmail] = useState('')
  const [userName, setUserName] = useState('')

  const onCodeSent = data => {
    setPhoneData(data)
    setStep('enterCode')
  }

  const onAuthenticated = ({ uid: authenticatedUid, email, name }) => {
    setUid(authenticatedUid)
    setUserEmail(email || '')
    setUserName(name || '')
    setStep('buy')
  }

  const mainContent = () => {
    if (step === 'enterCode' && phoneData) {
      return (
        <EnterVerificationCodeScreen
          phoneData={phoneData}
          onAuthenticated={onAuthenticated}
          onBack={() => setStep('enterPhone')}
        />
      )
    }
    if (step === 'enterPhone') {
      return (
        <EnterPhoneNumberScreen
          onCodeSent={onCodeSent}
          onBack={() => setStep('landing')}
        />
      )
    }
    if (step === 'buy' && uid) {
      return (
        <BuyPremiumScreen
          uid={uid}
          initialEmail={userEmail}
          initialName={userName}
          initialPhoneNumber={phoneData?.mobileNumber}
          initialCountryCode={phoneData?.countryCode}
        />
      )
    }
    return <PremiumLandingScreen onGetStarted={() => setStep('enterPhone')} />
  }

  return (
    <Routes>
      <Route path="success" element={<PremiumSuccessScreen />} />
      <Route path="cancel" element={<PremiumCancelScreen />} />
      <Route path="*" element={mainContent()} />
    </Routes>
  )
}

export default PremiumRoute
